import WorkflowModel from '@opsbase/lib-data-model/models/WorkflowModel';
import Event from '@opsbase/lib-event';
import { eventLabel } from '@opsbase/lib-event/Event';
import i18n from '@opsbase/lib-i18n';
import Horizontal from '@opsbase/web-layout/Horizontal/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import calcScheduleTitle from '@opsbase/web-op-scheduler/helpers/calcScheduleTitle';
import React, { useCallback, useState } from 'react';
import WorkflowDialogActions from './WorkflowDialogActions';
import WorkflowDialogColumn from './WorkflowDialogColumn';
import WorkflowDialogConditions from './WorkflowDialogConditions';
import WorkflowScheduleEditDialog from './WorkflowScheduleEditDialog';
export function WorkflowDialog(props) {
    const { workflow = new WorkflowModel() } = props;
    let title = (i18n.t('whenever') + ' ' + eventLabel(workflow === null || workflow === void 0 ? void 0 : workflow.event)).toUpperCase();
    const [showDialog, setShowDialog] = useState();
    if ((workflow === null || workflow === void 0 ? void 0 : workflow.event) === Event.SCHEDULE) {
        title = calcScheduleTitle(workflow === null || workflow === void 0 ? void 0 : workflow.schedule);
    }
    const handleCloseDialog = useCallback(() => setShowDialog(undefined), []);
    const handleEditSchedule = useCallback(() => {
        setShowDialog('edit');
    }, []);
    return (React.createElement(Vertical, { padding: true },
        React.createElement(WorkflowDialogColumn, { shrink: true, title: title, onEdit: (workflow === null || workflow === void 0 ? void 0 : workflow.event) === Event.SCHEDULE ? handleEditSchedule : undefined }),
        React.createElement(Horizontal, { gutter: true },
            React.createElement(WorkflowDialogConditions, { ...props }),
            React.createElement(WorkflowDialogActions, { ...props })),
        showDialog === 'edit' && (React.createElement(WorkflowScheduleEditDialog, { workflow: workflow, open: true, onClose: handleCloseDialog }))));
}
export default WorkflowDialog;
